import { MUNLIGHT_BOOKING_URL } from './munlightTheme';

/**
 * Dati modulari dei concerti della rassegna Munlight Sonata.
 * Aggiornare `imageSrc` con file in /public/munlight/ quando disponibili.
 */
export const MUNLIGHT_CONCERTS = [
  {
    id: 'glimmer-four-elements',
    imageSrc: '/munlight/placeholder.svg',
    imageAlt: 'I quattro elementi — Glimmer All Stars',
    title: 'I quattro elementi',
    subtitle: 'di Glimmer All Stars',
    audience: 'Percorso consigliato per ADULTI e FAMIGLIE',
    description: [
      'Dalla mente di Michaela Senetta e dagli arrangiamenti di Filippo Donà nasce un lavoro in cui narrazione parlata e sonora si fondono dando vita a una sinestesia artistica evocata attraverso le voci e gli strumenti dei 14 componenti dell’ensemble. Ognuno dei 4 elementi è introdotto da una voce narrante che guida l’ascoltatore, offrendo una diversa chiave di lettura dell’elemento proposto lasciando poi voce alla musica, la quale intreccia i più diversi stili musicali: dal Musical Theatre al Pop, dalla Classica al Rock.',
      'Ogni elemento diventa così uno spettacolo nello spettacolo in cui i timbri strumentali e le voci dei cantanti evocano immagini e emozioni che sarà poi compito dello spettatore stesso interpretare a suo modo, un mondo di alchimie sonore.',
    ],
    formation: [
      'Michaela Senetta — ideazione e narrazione',
      'Filippo Donà — arrangiamenti',
      'Ensemble Glimmer All Stars (14 musicisti)',
    ],
    dateLabel: '26 aprile',
    timeLabel: null,
    ctaLabel: 'Scopri / Prenota',
    ctaHref: MUNLIGHT_BOOKING_URL,
    variantDocumentId: null,
  },
  {
    id: 'volunteered-jazz',
    imageSrc: '/munlight/placeholder.svg',
    imageAlt: 'Volunteered — breve storia del jazz in 7 brani',
    title: 'Volunteered – breve storia del jazz in 7 brani',
    subtitle: 'di Gabriele Cappello 4tet',
    audience: 'Percorso consigliato per ADULTI e FAMIGLIE',
    description: [
      'Il quartetto di Gabriele Cappello racconta una piccola storia del Jazz attraverso le composizioni di alcuni dei musicisti più rappresentativi del fermento intellettuale e sociale che ha caratterizzato la nascita e lo sviluppo di questo genere.',
      'Il “Jazz” è l’espressione musicale di un fenomeno culturale molto più ampio che, a cavallo tra la fine dell’800 e la prima metà del ‘900, ha permesso alle comunità più emarginate e svantaggiate all’interno degli Stati Uniti di trovare un linguaggio comune attraverso la musica, generando uno dei fenomeni artistici più innovativi del XX secolo la cui storia pertanto si intreccia inevitabilmente con quella degli interpreti che, attraverso la ricerca della propria libertà espressiva, hanno reclamato il diritto di esistere di tutti gli emarginati del mondo.',
    ],
    formation: ['Gabriele Cappello 4tet'],
    dateLabel: '24 maggio',
    timeLabel: null,
    ctaLabel: 'Scopri / Prenota',
    ctaHref: MUNLIGHT_BOOKING_URL,
    variantDocumentId: null,
  },
  {
    id: 'bow-the-air',
    imageSrc: '/munlight/placeholder.svg',
    imageAlt: 'Bow the air — Quartetto Echo',
    title: 'Bow the air',
    subtitle: 'di Quartetto Echo',
    audience: 'Percorso consigliato per ADULTI e FAMIGLIE',
    description: [
      'Il concerto esplora un’insolita formazione: il quartetto per flauto e archi. Poco frequente nella storia della musica, esso trova, anche grazie al lavoro di Wolfgang Amadeus Mozart e di Ferdinand Ries, un momento favorevole nel Periodo Classico. Da qui il nome “Bow the Air” che acquisisce così due significati: evidenziare il legame tra strumenti dal differente timbro e colore (bow-arco; air-fiato) e la riverenza musicale (to bow) dei tre archi verso lo strumento quasi solista ossia il flauto.',
      'W. A. Mozart (1756-1791), nonostante la risaputa antipatia per il flauto traverso, accettò, durante il periodo di permanenza a Mannheim, la commissione propostagli dal musicista dilettante Ferdinand De Jean di comporre ben tre quartetti per questo strumento. Si tratta di lavori freschi e luminosi, dal carattere giovanile, dei quali spicca quello in Re maggiore.',
      'Ferdinand Ries (1784-1838), assistente e amico di Beethoven, nonché suo importante biografo, fu un compositore prolifico. Nonostante nella sua musica si riflettano lo stile e l’ammirazione per il maestro, i quartetti per flauto mostrano una ricerca più personale, che rivela non imitazione ma profonda comprensione e tensione musicale e il quartetto n. 1 in Re minore è l’esemplificazione sonora di questi caratteri.',
    ],
    formation: ['Quartetto Echo'],
    dateLabel: '21 giugno',
    timeLabel: null,
    ctaLabel: 'Scopri / Prenota',
    ctaHref: MUNLIGHT_BOOKING_URL,
    variantDocumentId: null,
  },
  {
    id: 'west-side-stories',
    imageSrc: '/munlight/placeholder.svg',
    imageAlt: 'West Side Stories — Long Story Short',
    title: 'West Side Stories',
    subtitle: 'di Long Story Short',
    audience: 'Percorso consigliato per ADULTI e FAMIGLIE',
    description: [
      'Nella storia della musica si trovano spesso in contrapposizione, secondo principi accademici, due tipi di musica: quella che viene definita “colta” e quella indicata come “musica popolare”. Ma quando questo dualismo perde le proprie barriere e i suoi contorni sfumano cosa otteniamo?',
      'L’ensemble “Long Story Short”, attraverso il dialogo musicale tra 5 percussionisti, dà una risposta a questa domanda proponendo brani in cui il carattere popolare si lega in modo profondo a uno studio musicale ricercato e di alto livello, opere in cui i compositori infondono le più svariate identità tradizionali nelle architetture della musica classica.',
      'Il cuore pulsante del concerto, e non solo perché eseguito su marimbe, vibrafoni e altri strumenti a percussione, sarà la suite (trascritta appositamente per questi strumenti) di brani tratti dall’incredibile musical di Leonard Bernstein “West Side Story”, composizioni nelle quali ritmi e melodie del “melting-pot” americano hanno modo di essere rappresentate appieno.',
    ],
    formation: ['Long Story Short — ensemble di 5 percussionisti'],
    dateLabel: '27 settembre',
    timeLabel: null,
    ctaLabel: 'Scopri / Prenota',
    ctaHref: MUNLIGHT_BOOKING_URL,
    variantDocumentId: null,
  },
  {
    id: 'japan-2d-dreams',
    imageSrc: '/munlight/placeholder.svg',
    imageAlt: 'Japan 2D dreams — A-Name Quartet',
    title: 'Japan 2D dreams',
    subtitle: 'di A-Name Quartet',
    audience: 'Percorso consigliato per ADULTI e FAMIGLIE',
    description: [
      'Maestri dell’arte dell’animazione, i disegnatori giapponesi si sono destreggiati per decenni nel creare storie, immagini e stili che si sono impressi nella memoria del loro pubblico in modo indelebile, come la china sulle loro tavole. Ma per quanto evocativi siano i loro capolavori questi ultimi non possono esistere senza la magia musicale datagli dai compositori nipponici, abili musicisti nel creare un saldo legame tra immagine e suono.',
      'Tra queste opere a tutto tondo spiccano i lavori dello studio Ghibli creato da Hayao Miyazaki, opere che hanno creato un vero e proprio stile di animazione che si è allargato a macchia d’olio nella cultura pop mondiale: chi non ha mai sentito titoli come “Il Castello Errante di Howl”, “La Città Incantata”, “Il mio vicino Totoro” o “La Principessa Mononoke”?',
      'Spetta al quartetto d’archi “A-name Quartet” il compito di ripercorrere musicalmente la storia di questo grande studio, attraverso arrangiamenti inediti dei brani del compositore di punta della Ghibli, Joe Hisaishi.',
    ],
    formation: ['A-Name Quartet — quartetto d’archi'],
    dateLabel: 'Data in definizione',
    timeLabel: null,
    ctaLabel: 'Scopri / Prenota',
    ctaHref: MUNLIGHT_BOOKING_URL,
    variantDocumentId: null,
  },
];

export const MUNLIGHT_INTRO_PARAGRAPHS = [
  'Quando il tangibile e l’intangibile si incontrano nasce “Munlight Sonata”.',
  'La rassegna prende forma all’interno degli spazi del Munlab, dove la dimensione fisica dell’ex fornace dialoga con quella sonora della musica, creando un’esperienza che unisce ambiente, ascolto e immaginazione.',
  'Come le argille che un tempo venivano lavorate e trasformate, anche la musica qui si stratifica, si mescola e prende forma, costruendo architetture sonore che attraversano generi, linguaggi e sensibilità diverse.',
  'I concerti della rassegna spaziano tra pop, classica, jazz e colonne sonore, dando vita a esperienze sempre diverse, in cui lo spazio non è solo contenitore ma parte attiva dell’ascolto.',
  'Munlight Sonata è un percorso: un modo per abitare il suono e lasciarsi attraversare da esso.',
];
